import { DynamicIcon } from 'components/atoms/Icons'
import React, { useEffect, useState, useId } from 'react'


interface Props {
    checked: boolean
    onChange: (value: boolean) => void
    labelTrue?: string
    labelFalse?: string
    disabled?: boolean
}

const AppSwitchToggle = ({
    checked,
    onChange,
    labelTrue = 'Si',
    labelFalse = 'No',
    disabled = false,
}: Props) => {
    const [isChecked, setIsChecked] = useState(checked)
    const switchId = useId()

    useEffect(() => {
        setIsChecked(checked)
    }, [checked])

    const handleSelect = (value: boolean) => {
        if (disabled) return
        setIsChecked(value)
        onChange(value)
    }

    return (
        <div
            role="switch"
            aria-checked={isChecked}
            aria-disabled={disabled}
            data-testid="app-switch-toggle"
            className={`inline-flex items-center rounded-md bg-shark-50 p-1 gap-1 h-10 w-[165px]${
                disabled ? 'opacity-50 cursor-not-allowed' : ''
            }`}
        >
            {/* Option: Si */}
            <button
                type="button"
                id={`switch-true-${switchId}`}
                aria-pressed={isChecked}
                onClick={() => handleSelect(true)}
                disabled={disabled}
                className={`flex items-center gap-1.5 px-5 py-3 rounded text-sm font-semibold transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-shark-400 w-[76px] h-8 ${
                    isChecked
                        ? 'bg-neutral-white text-shark-950'
                        : 'bg-transparent text-shark-400 hover:text-shark-600'
                } ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}
            >
                <DynamicIcon name='check' />
                <span>{labelTrue}</span>
            </button>

            {/* Option: No */}
            <button
                type="button"
                id={`switch-false-${switchId}`}
                aria-pressed={!isChecked}
                onClick={() => handleSelect(false)}
                disabled={disabled}
                className={`flex items-center gap-1.5 px-5 py-3 rounded text-sm font-semibold transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-shark-400 w-[76px] h-8 ${
                    !isChecked
                        ? 'bg-neutral-white text-shark-950 '
                        : 'bg-transparent text-shark-400 hover:text-shark-600'
                } ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}
            >
                <DynamicIcon name='close' />
                <span>{labelFalse}</span>
            </button>
        </div>
    )
}

export default AppSwitchToggle
